import {vw_store_inventory} from 'openapi'

export interface TransferProductProps {
  show?: boolean
  transferProduct: vw_store_inventory[]
}

const initState: TransferProductProps = {
  show: false,
  transferProduct: [],
}

export const transferProductTypes = {
  GET_PRODUCTS: 'GET_PRODUCTS',
  SELECT_PRODUCT: 'SELECT_PRODUCT',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  UPDATE_PRODUCT_QUANTITY: 'UPDATE_PRODUCT_QUANTITY',
  UPDATE_PRODUCT_PRICE: 'UPDATE_PRODUCT_PRICE',
  CLEAR_CART: 'CLEAR_CART',
  SHOW_MODAL: 'SHOW_MODAL',
}

export const transferProductModalActions = {
  getProducts: async () => ({type: transferProductTypes.GET_PRODUCTS}),
  selectProduct: (obj: vw_store_inventory) => ({type: transferProductTypes.SELECT_PRODUCT, obj}),
  deleteProduct: (productId: string) => ({type: transferProductTypes.DELETE_PRODUCT, productId}),
  clearCart: async () => ({type: transferProductTypes.CLEAR_CART}),
  showModal: (value: boolean) => ({type: transferProductTypes.SHOW_MODAL, value}),
  updateProductQuantity: (productId: string, quantity: number) => ({
    type: transferProductTypes.UPDATE_PRODUCT_QUANTITY,
    productId,
    quantity,
  }),
  updateProductPrice: (productId: string, price: number) => ({
    type: transferProductTypes.UPDATE_PRODUCT_PRICE,
    productId,
    price,
  }),
}

const transferProductReducer = (state = initState, action: any): TransferProductProps => {
  switch (action.type) {
    case transferProductTypes.SHOW_MODAL:
      return {
        ...state,
        show: action.value,
      }
    case transferProductTypes.GET_PRODUCTS:
      return {
        ...state,
      }
    case transferProductTypes.SELECT_PRODUCT:
      return {
        ...state,
        transferProduct: [...state.transferProduct, action.obj],
      }
    case transferProductTypes.UPDATE_PRODUCT_QUANTITY:
      return {
        ...state,
        transferProduct: state.transferProduct.map((product) => (product.product_id === action.productId ? {...product, quantity: action.quantity} : product)),
      }
    case transferProductTypes.UPDATE_PRODUCT_PRICE:
      return {
        ...state,
        transferProduct: state.transferProduct.map((product) => (product.product_id === action.productId ? {...product, selling_price: action.price} : product)),
      }
    case transferProductTypes.DELETE_PRODUCT:
      return {
        ...state,
        transferProduct: state.transferProduct.filter((product) => product.product_id !== action.productId),
      }
    case transferProductTypes.CLEAR_CART:
      return {
        ...state,
        show: false,
        transferProduct: [],
      }
    default:
      return {...state}
  }
}

export {transferProductReducer}
